<template>
    <div class="container">

        <p class="page_title">회원 목록</p>

        <section class="section sec1">
            <div class="sec_titbox h_80">
                <div class="leftbox">
                    <p class="tit">총회원 수 <span class="color">{{ userList.length }}</span>명</p>
                </div>
                <div class="rightbox">
                    <div class="planstate_box">
                        <div class="item">
                            <img :src="`${$STATIC_URL}/admin/img/plan_p.png`" alt="" class="icon">
                            <span class="txt">{{ getPremiumUserCount }}</span>
                        </div>
                        <div class="item">
                            <img :src="`${$STATIC_URL}/admin/img/plan_b.png`" alt="" class="icon">
                            <span class="txt">{{ getBasicUserCount }}</span>
                        </div>
                        <div class="item">
                            <img :src="`${$STATIC_URL}/admin/img/plan_f.png`" alt="" class="icon">
                            <span class="txt">{{ getFreeUserCount }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section sec2">
            <div class="sec_titbox">
                <div class="leftbox">
                    <div class="input_box date">
                        <VueDatePicker range :enable-time-picker="false" :model-value="rangeDate"
                            @update:model-value="searchFilter" :clearable="false" :teleport="true" />
                    </div>
                </div>
                <div class="rightbox">
                    <div class="input_box big">
                        <input type="text" placeholder="이메일을 입력하세요." class="input_text search" v-model="search"
                            @keyup="searchDatatables">
                    </div>
                    <button type="button" class="btn ver2 reset_btn" @click="resetSearch">
                        <span class="icon"></span>
                        <span class="txt">초기화</span>
                    </button>
                </div>
            </div>
            <div class="tbl_wrap">
                <DataTable ref="table" :data="userList" class="tbl" :columns="columns" :options="dtOptions"></DataTable>
            </div>
        </section>
        <UserDetailModal v-if="userDetailModal" :userDetail="userDetail" @userDetailModalClose="userDetailModalClose"
            @prevUserDetail="prevUserDetail" @nextUserDetail="nextUserDetail" @banUserReq="banUserReq" />
    </div>
</template>
<script setup>
import moment from 'moment';
import { getUserList, banUser } from '@/api';
import { onMounted, ref, computed, getCurrentInstance } from 'vue';
import UserDetailModal from '@/components/UserDetailModal.vue';
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net';
import { useStore } from "vuex";
const store = useStore();
const { proxy } = getCurrentInstance();

DataTable.use(DataTablesCore);

const dtOptions = {
    paging: true,  // 페이지네이션 활성화
    searching: true,  // 검색 활성화
    info: false,
    pageLength: 10,
    lengthChange: false,
    language: {
        emptyTable: '데이터가 없습니다.', // 메시지 변경
    },
}

const userDetailModal = ref(false);
let userList = ref([]);

const userDetail = ref({});

const userDetailModalClose = () => {
    userDetailModal.value = false;
}

const nextUserDetail = (data) => {
    const index = userList.value.findIndex(user => user.uid === data);
    if (index < userList.value.length - 1) {
        userDetail.value = userList.value[index + 1];
    } else {
        userDetail.value = userList.value[0];
    }
}

const prevUserDetail = (data) => {
    const index = userList.value.findIndex(user => user.uid === data);
    if (index > 0) {
        userDetail.value = userList.value[index - 1];
    } else {
        userDetail.value = userList.value[userList.value.length - 1];
    }
}

const banUserReq = async (data) => {
    const res = await banUser(data);
    if (res.status == 200) {
        const user = userList.value.find(user => user.uid === data.uid);
        if (user.is_ban == 0) {
            store.commit('setRefreshModal', '정지 처리되었습니다.');
        } else {
            store.commit('setRefreshModal', '정지 해제되었습니다.');
        }
    }

}

const columns = [
    { data: null, title: 'No', render: (data, type, row, meta) => meta.row + 1 },
    {
        data: 'type', title: '전체', render: (data) => {
            switch (data) {
                case 0: return '유료';
                case 1: return '유료';
                case null: return '무료';
            }
        }
    },
    {
        data: 'email', title: '이메일', render: (data) => {
            return `<a href="#none" class="email-link">${data}</a>`;
        },
        createdCell: (td, cellData, rowData) => {
            td.querySelector('.email-link').addEventListener('click', (event) => {
                event.preventDefault(); // 기본 동작 방지
                userDetailModal.value = true;
                
                userDetail.value = rowData;
            });
        }
    },

    {
        data: 'reg_date', title: '가입일', render: (data) => {
            return moment(data).format('YYYY-MM-DD');
        }
    },
    {
        data: 'type', title: '플랜', render: (data) => {
            switch (data) {
                case 0: return `<img src="${proxy.$STATIC_URL}/admin/img/plan_b.png" alt="" class="plan_icon">`;
                case 1: return `<img src="${proxy.$STATIC_URL}/admin/img/plan_p.png" alt="" class="plan_icon">`;
                case null: return `<img src="${proxy.$STATIC_URL}/admin/img/plan_f.png" alt="" class="plan_icon">`;
            }
        }
    },
    {
        data: 'end_date', title: '사용기간', render: (data, type, row) => {
            if (row.is_ban == 1) {
                return "정지 인원";
            } else if (data == null) {
                return "무료 인원";
            } else {
                
                return `${moment(row.start_date).format('YYYY-MM-DD')} ~ ${moment(data).format('YYYY-MM-DD')}`
            }
        }
    },
    {
        data: 'uid', title: '당첨정보', render: () => {
            return `<span class="point_color">0</span>`
        }
    },
];

const table = ref();
const rangeDate = ref('');

onMounted(async () => {
    const res = await getUserList();
    userList.value = [...res.data.userList];

})


const searchFilter = (modelData) => {
    rangeDate.value = modelData;
    const dt = table.value.dt;
    dt.rows().every(function () {
        const row = this.data();
        const rowDate = new Date(row.reg_date);
        const rowNode = this.node();
        const [startDate, endDate] = rangeDate.value;
        if (rowDate >= startDate && rowDate <= endDate) {
            rowNode.style.display = '';
        } else {
            rowNode.style.display = 'none';
        }
    });
    dt.draw(false);
}


const search = ref('');
const searchDatatables = () => {
    const dt = table.value.dt;
    dt.search(search.value).draw();
}

const resetSearch = () => {
    search.value = '';
    const dt = table.value.dt;
    dt.search('').draw();
}

const getFreeUserCount = computed(() => {
    return userList.value.filter(user => user.type === null).length;
})
const getBasicUserCount = computed(() => {
    return userList.value.filter(user => user.type === 0).length;
})
const getPremiumUserCount = computed(() => {
    return userList.value.filter(user => user.type === 1).length;
})

</script>
<style scoped>
:deep(.dt-paging-button) {
    width: 40px;
    height: 40px;
    font-size: 14px;
    line-height: 157%;
    letter-spacing: -0.04em;
    color: var(--color-text);
    border: 1px solid var(--color-border2);
    border-radius: 8px;
    background: var(--color-white);
    overflow: hidden;
    margin: 0 10px;
}

:deep(.dt-paging-button.current) {
    font-weight: 700;
    color: var(--color-white);
    background: var(--color-gradient1);
}

:deep(.dt-paging nav) {
    display: flex;
    justify-content: center;
}

:deep(.dt-paging) {
    margin-top: 20px;
    margin-bottom: 20px;
}

:deep(.dt-search) {
    display: none
}
</style>